import { render, staticRenderFns } from "./upload-btn.generic.vue?vue&type=template&id=44150cd0&"
import script from "./upload-btn.generic.vue?vue&type=script&lang=js&"
export * from "./upload-btn.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports